import { FiltersService } from '@/app/services/FiltersService'
import { GalleryService } from '@/app/services/GalleryService'
import { Album, layoutActions } from '@Techedge/digitalportal-shared'
import { statusIconMap } from '@/app/models/photo.status'

export const AlbumsActions = {
    GET_ALBUM_DETAIL_SUCCESS: 'GET_ALBUM_DETAIL_SUCCESS',
    SET_ALBUM_DETAILS: 'SMART_GALLERY_SET_ALBUM_DETAILS',
    SHOW_ALBUM_PREVIEW: 'SHOW_ALBUM_PREVIEW',
    SAVE_NEW_ALBUM: 'SAVE_NEW_ALBUM',
    SAVE_EDITED_ALBUM: 'SAVE_EDITED_ALBUM',
    GET_ALBUM_DETAIL_REQUEST: 'GET_ALBUM_DETAIL_REQUEST',
    SET_ALBUM_DETAILS_SUCCESS: 'SET_ALBUM_DETAILS_SUCCESS',
    SET_ALBUM_DETAILS_ERROR: 'SET_ALBUM_DETAILS_FAILURE',
    SET_PROJECT_FOR_MANUAL_PHOTO_SELECTION: 'SET_PROJECT_FOR_MANUAL_PHOTO_SELECTION',
}

const albumAdapter = (album: Album) => {
    let newAlbum: any = { ...album }
    newAlbum.distribution.stores = album.distribution.stores.map(
        (store: any) => store.store_id ?? store
    )
    newAlbum.distribution.people = album.distribution.people?.map((user: any) => ({
        name: user.firstname,
        lastname: user.lastname,
        nickname: user.nickname,
        userId: user?.userId,
    }))

    newAlbum.specialCollection = !!album.specialCollection
    newAlbum.filters = {
        ...album.filters,
    }
    if (album.filters?.storeIds) {
        newAlbum.filters.storeIds = album.filters.storeIds.map((store: any) => store.store_id)
    }
    if (album.filters?.from) {
        newAlbum.filters.from = album.filters.from.getTime()
    }
    if (album.filters?.to) {
        newAlbum.filters.to = album.filters.to.getTime()
    }
    if (album.manualAttachments) {
        newAlbum.manualAttachments = album.manualAttachments.map((attachment: any) => attachment.id)
    }
    if (album.filters?.selectedProjects) {
        newAlbum.filters.projectIds =
            album.filters.selectedProjects == '*'
                ? '*'
                : album.filters.selectedProjects.map((sp) => sp.id)
        delete newAlbum.filters.selectedProjects
    }
    delete newAlbum.lastUpdateDate
    delete newAlbum.modifierUserInfo
    delete newAlbum.creatorUserInfo

    return newAlbum
}

export const setPreviewDetails = (data: any) => {
    return {
        type: AlbumsActions.GET_ALBUM_DETAIL_SUCCESS,
        albumDetail: data,
    }
}

export const setAlbumDetails = (data: any) => {
    return {
        type: AlbumsActions.SET_ALBUM_DETAILS,
        data,
    }
}

export const saveNewAlbum = (albumData: any, successMessage: string) => {
    return (dispatch: any) => {
        dispatch(setAlbumDetailsRequest())
        GalleryService.CreateAlbum(albumAdapter(albumData))
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(setAlbumDetailsSuccess(successMessage))
                    dispatch(setAlbumDetails(new Album()))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: {
                                id: null,
                                isEdit: false,
                                isPreview: false,
                                savedAlbumId: res.data.id,
                            },
                        })
                    )
                } else {
                    dispatch(setAlbumDetailsError(res.data.output.payload.message))
                }
            })
            .catch((error) => {
                dispatch(setAlbumDetailsError(error.response?.data?.message || error.message))
            })
    }
}

export const editAlbum = (albumData: any, successMessage: string) => {
    return (dispatch: any) => {
        dispatch(setAlbumDetailsRequest())
        GalleryService.EditAlbum(albumAdapter(albumData))
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(setAlbumDetailsSuccess(successMessage))
                    dispatch(setAlbumDetails(new Album()))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: {
                                id: null,
                                isEdit: false,
                                isPreview: false,
                                savedAlbumId: res.data.id,
                            },
                        })
                    )
                } else {
                    dispatch(setAlbumDetailsError(res.data.output.payload.message))
                }
            })
            .catch((error) => {
                dispatch(setAlbumDetailsError(error.response?.data?.message || error.message))
            })
    }
}
export const previewAlbum = (albumData: any) => {
    return (dispatch: any) => {
        dispatch(setAlbumDetailsRequest())
        GalleryService.PreviewAlbum(albumAdapter(albumData))
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(setPreviewDetails(res.data))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, isEdit: false, isPreview: true },
                        })
                    )
                } else {
                    dispatch(setAlbumDetailsError(res.data.output.payload.message))
                }
            })
            .catch((error) => {
                dispatch(setAlbumDetailsError(error.response?.data?.message || error.message))
            })
    }
}

export const getAlbumDetails = (albumId: string) => {
    return (dispatch: any) => {
        dispatch(setAlbumDetailsRequest())
        GalleryService.GetAlbumDetails(albumId)
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    let album = { ...res.data }
                    if (album.filters.to) album.filters.to = new Date(album.filters.to)
                    if (album.filters.from) album.filters.from = new Date(album.filters.from)
                    album.distribution.stores = album.distribution.storeIds.map((store: any) => ({
                        store_id: store,
                    }))
                    delete album.distribution.storeIds
                    album.distribution.people = album.distribution.people.map((user: any) => ({
                        userId: user?.userId,
                        firstname: user.name,
                        lastname: user.lastname,
                        nickname: user.nickname,
                    }))
                    if (album.manualAttachments) {
                        album.manualAttachments = album.manualAttachments.map(
                            (attachment: any) => ({
                                url: attachment.url,
                                urlThumbnail: attachment.urlThumbnail,
                                macroarea: attachment.macroarea,
                                status: {
                                    name: attachment.status,
                                    ...statusIconMap[attachment.status],
                                },
                                id: attachment.id,
                                name: attachment.name,
                                storeId: attachment.reference.storeId,
                            })
                        )
                    }
                    if (album.filters.storeIds) {
                        FiltersService.GetStoreList({
                            mode: 'standard',
                            tableFilters: { storeIdList: album.filters.storeIds },
                        }).then((res) => {
                            album.filters.storeIds = res.data?.stores?.map((store: any) => ({
                                store_name: store.store_name,
                                store_id: store.store_id,
                            }))
                            dispatch(setAlbumDetails(album))
                        })
                    } else {
                        dispatch(setAlbumDetails(album))
                    }
                    dispatch(setAlbumDetailsSuccess())
                } else {
                    dispatch(setAlbumDetailsError(res.data.output.payload.message))
                }
            })
            .catch((error) => {
                dispatch(setAlbumDetailsError(error.response?.data?.message || error.message))
            })
    }
}

export const setAlbumDetailsRequest = () => {
    return { type: AlbumsActions.GET_ALBUM_DETAIL_REQUEST }
}

export const setAlbumDetailsSuccess = (text?: string) => {
    return {
        type: AlbumsActions.SET_ALBUM_DETAILS_SUCCESS,
        ...(text && {
            toastList: [
                {
                    text,
                },
            ],
        }),
    }
}

export const setAlbumDetailsError = (error: any) => {
    return {
        type: AlbumsActions.SET_ALBUM_DETAILS_ERROR,
        toastList: [
            {
                text: error,
            },
        ],
    }
}

export const setProjectForManualPhotoSelection = (id: Album) => ({
    type: AlbumsActions.SET_PROJECT_FOR_MANUAL_PHOTO_SELECTION,
    id,
})
